import React from 'react';
import { Headphones, BookOpen } from 'lucide-react';
export function DigitalOptions() {
  return <section className="py-16 px-6 bg-white" data-id="element-21">
      <div className="max-w-4xl mx-auto text-center" data-id="element-22">
        <h2 className="text-3xl font-bold text-[#1E3A5F] mb-6" data-id="element-23">
          Prefer Digital?
        </h2>
        <p className="text-lg text-gray-600 mb-10" data-id="element-24">
          The e-book and audio versions of Applied Wisdom are also available for
          free instant download.
        </p>
        <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-25">
          <a href="https://www.appliedwisdomfornonprofits.org/download/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-[#1E3A5F] hover:bg-[#162b45] text-white font-medium py-3 px-6 rounded-md transition-colors" data-id="element-26">
            <BookOpen size={20} className="mr-2" data-id="element-27" />
            Download E-book
          </a>
          <a href="https://www.appliedwisdomfornonprofits.org/download/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-[#1E3A5F] hover:bg-[#162b45] text-white font-medium py-3 px-6 rounded-md transition-colors" data-id="element-28">
            <Headphones size={20} className="mr-2" data-id="element-29" />
            Download Audio
          </a>
        </div>
        {/* Holiday decoration */}
        <div className="mt-12 flex justify-center" data-id="element-30">
          <div className="h-1 w-16 bg-red-400 rounded-full mx-1" data-id="element-31"></div>
          <div className="h-1 w-16 bg-green-400 rounded-full mx-1" data-id="element-32"></div>
          <div className="h-1 w-16 bg-red-400 rounded-full mx-1" data-id="element-33"></div>
        </div>
      </div>
    </section>;
}